import React from "react";
import portfolioPhoto from "../../assets/images/MyPortfolioImage2.png";
import portfoliophotoCartoonic from '../../assets/images/profileImgCatoonic.png'
import myCartoonicImg from '../../assets/images/my-cartoonic-img.png'
import myPorfolioImg2 from '../../assets/images/my-portfolio-img-2.png'
import PortfolioImgUpdated from '../../assets/images/profileImgUpdated.png'
import "./FeelingProud.css";

function FeelingProud(props) {
  // const theme = props.theme;
  return <img src={PortfolioImgUpdated} alt="portfolio-profile" />;
}

export default FeelingProud;
